import { Fragment, useEffect } from 'react'
import { useRouter } from 'next/router'

import { LOGIN_VIEW } from '~/auth/types/login.types'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import { AuthenticateV2 } from '~/auth/components/v2/AuthenticateV2'

import { AuthTypes } from '../types/auth.types'

import { selectView, setViewActionCreator } from '../slices/login.slice'

import Authenticate from './Authenticate'
import { AuthenticateWithEmail } from './AuthenticateWithEmail'
import AuthenticateWithSSO from './AuthenticateWithSSO'

export default function ShowLoginForm({ isMobileApp }: { isMobileApp?: boolean }): React.ReactElement {
  const loginView = useAppSelector(selectView)
  const dispatch = useAppDispatch()

  const router = useRouter()
  const queryParam = router.query

  const recoveryFlow = Boolean(router.isReady && queryParam['recover'])

  useEffect(() => {
    if (recoveryFlow) {
      dispatch(setViewActionCreator(LOGIN_VIEW.ENTER_PASSWORD))
    }
  }, [dispatch, recoveryFlow])

  function renderView(): React.ReactElement {
    if (isMobileApp) {
      return <AuthenticateV2 />
    }
    switch (loginView) {
      case LOGIN_VIEW.DEFAULT:
        return <Authenticate />

      case LOGIN_VIEW.ENTER_PASSWORD:
        return <AuthenticateWithEmail hidePassResetButton={recoveryFlow} />

      case LOGIN_VIEW.CONTINUE_WITH_FACEBOOK:
        return <AuthenticateWithSSO provider={AuthTypes.FACEBOOK} />

      case LOGIN_VIEW.CONTINUE_WITH_GOOGLE:
        return <AuthenticateWithSSO provider={AuthTypes.GOOGLE} />

      default:
        return <Fragment />
    }
  }

  return renderView()
}
